import { render } from "./DividerBottom.vue?vue&type=template&id=74a76a5a"
const script = {}

import "./DividerBottom.vue?vue&type=style&index=0&id=74a76a5a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__